import { apiRequest } from "../api";
import apiPaths from "../api/paths";
import {
  REMOVE_USER_TOKEN_DATA,
  SET_USER_TOKEN_DATA,
  SET_SELF_USER_DATA,
  REMOVE_USER_DATA,
  SET_BATTERY_USER,
} from "./types";

export const setUserTokenData = (data) => ({
  type: SET_USER_TOKEN_DATA,
  data: data,
});

export const setBatteryUser = (data) => ({
  type: SET_BATTERY_USER,
  data: data,
});

export const setSelfUserInfo = (data) => ({
  type: SET_SELF_USER_DATA,
  data: data,
});

export const removeUserTokenData = () => ({
  type: REMOVE_USER_TOKEN_DATA,
});

export const removeUserData = () => ({
  type: REMOVE_USER_DATA,
});

export const logoutUser = () => {
  return (dispatch) => {
    dispatch(removeUserTokenData());
  };
};

export const setLoginUser = (data) => {
  return async (dispatch) => {
    let self = await dispatch(getSelfUser(data));
    if (self.error) {
      return self;
    }
    await dispatch(setUserTokenData(data));
  };
};

export const deleteUserData = () => {
  return (dispatch) => {
    dispatch(removeUserData());
  };
};

export const getSelfUser = (tokenData = null) => {
  return (dispatch) => {
    return apiRequest({
      path: apiPaths.self,
      token: tokenData,
    }).then((res) => {
      if (!res.error) {
        dispatch(setSelfUserInfo(res));
      }
      return res;
    });
  };
};

export const loginUser = (data) => {
  return (dispatch) => {
    return apiRequest({
      data: data,
      isLogin: true,
    }).then(async (res) => {
      if (!res.error && !res.is_two_step_enabled) {
        let self = await dispatch(getSelfUser(res));
        if (self.error || !self.is_admin) {
          return self;
        } else {
          res.is_admin = true;
        }
        dispatch(setUserTokenData(res));
      }
      return res;
    });
  };
};

export const verifyUser = (data) => {
  return (dispatch) => {
    return apiRequest({
      path: apiPaths.verify,
      method: "POST",
      secured: false,
      data: data,
    }).then(async (res) => {
      if (!res.error) {
        await dispatch(setLoginUser(res));
      }
      return res;
    });
  };
};
